"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselSkipLink = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselSkipLinkMixin = require("../../mixins/components/CarouselSkipLinkMixin");
var _Anchor = require("../Anchor/Anchor");
var StyledCarouselSkipLink = /*#__PURE__*/(0, _styledComponents.default)(_Anchor.Anchor).withConfig({
  displayName: "StyledCarouselSkipLink",
  componentId: "c11n-8-107-0__sc-uh66ps-0"
})(["", ""], _CarouselSkipLinkMixin.CarouselSkipLinkMixin);
exports.StyledCarouselSkipLink = StyledCarouselSkipLink;